var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.suggestion
    ? _c("div", { attrs: { id: "ai-assistant" }, on: { click: _vm.select } }, [
        _c("div", { staticClass: "icon", class: { loading: _vm.loading } }, [
          _c("span", { staticClass: "material-icons" }, [
            _vm._v(" auto_fix_high "),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.suggestion,
                expression: "suggestion",
              },
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { followCursor: true, placement: "bottom-end" },
                expression: "{ followCursor: true, placement: 'bottom-end' }",
              },
            ],
            staticClass: "suggestion-text",
            attrs: { content: _vm.suggestion },
          },
          [_vm._v("\n        " + _vm._s(_vm.suggestion) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticClass: "material-icons",
              attrs: {
                content:
                  "Bu mesaj  yapay zeka tarafından otomatik olarak oluşturulmuştur.Seçmek için üzerine tıkla veya CTRL + Enter tuşlarına bas.",
              },
            },
            [_vm._v("\n            help_outline\n        ")]
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "keyboard-shortcut" } }, [_vm._v("⌘ + ⏎")]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }